import type { TUser } from '@shared/types/user';
import type { TCurrency } from '@shared/types/currency';
import type { TLineItem } from '@shared/types/line-item';
import type { TOrganization } from '@shared/types/organization';
import type { ValueOf } from '@shared/types/utilities';
import type { TStudent } from '@shared/types/student';
import type { TLabel } from '@shared/types/label';

const INVOICE_STATUSES = {
  draft: 'DRAFT',
  pending: 'PENDING',
  paid: 'PAID',
  partiallyPaid: 'PARTIALLY_PAID',
  unPaid: 'UNPAID',
  overdue: 'OVERDUE',
} as const;

const DISCOUNT_TYPE = {
  amount: 'AMOUNT',
  percentage: 'PERCENTAGE',
} as const;

type TInvoice = {
  id: number;
  remaining?: number;
  currency: string;
  issued_by: TUser;
  issued_to: TUser;
  issued_to_student: TStudent;
  organization: TOrganization;
  line_items: TLineItem[];
  invoice_date: string;
  unique_id: string;
  status: ValueOf<typeof INVOICE_STATUSES>;
  discount_type: ValueOf<typeof DISCOUNT_TYPE>;
  discount_value: string;
  due_date: string;
  amount_paid: string;
  amount_paid_currency: TCurrency;
  total_before_discount: string;
  discount_amount: string;
  total_after_discount: string;
  note: string;
  created_at: string;
  formatted_sharable_uid?: string;
  updated_at: string;
  send_email: boolean;
  labels: TLabel[];
  pdf: string | null;
};

export { type TInvoice, INVOICE_STATUSES, DISCOUNT_TYPE };
